import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Campo de búsqueda nativo en la barra (buscador por tienda, Fase 2): manda placeholder y autofocus al conectar
// y publica cada término como "bridge--search:queried" { query } en window. Doc: brigde_component.md → Search
export default class extends BridgeComponent {
  static component = "search"

  connect() {
    super.connect()
    const placeholder = this.bridgeElement.bridgeAttribute("placeholder")
    const autofocus = this.bridgeElement.bridgeAttribute("autofocus") === "true"
    this.send("connect", { placeholder, autofocus }, message => {
      this.dispatch("queried", { detail: { query: message.data.query ?? "" } })
    })
  }
}
